import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import EmailInput from './EmailInput';

export const VALIDATE_EMAIL_MUTATION = gql`
  mutation validateEmail($email: String!) {
    validateEmail(email: $email) {
      email
      didYouMean
      formatValid
      mailboxStatus
    }
  }
`;

export default graphql(VALIDATE_EMAIL_MUTATION, {
  name: 'validateEmail',
  alias: 'withValidateEmail',
})(EmailInput);
